import React from "react";
import ListItem from "../../../ui_atoms/ListItem";
import { AbsenceInput } from "../../../__generated__/graphql";
import AbsenceCreateModal from "./AbsenceCreateModal";
import { useI18n } from "../../../hooks/i18n-hooks";
import { useTheme } from "../../../hooks/use-theme";

type AbsenceCreateButtonProps = {
    onCreate: (absence: AbsenceInput) => void;
    disabled?: boolean;
    minDate?: Date;
    maxDate?: Date;
};

const AbsenceCreateButton: React.FC<AbsenceCreateButtonProps> = ({
    onCreate,
    disabled = false,
    minDate,
    maxDate,
}) => {
    const { marginSize, colors } = useTheme();
    const [modalVisible, setModalVisible] = React.useState(false);
    const i18n = useI18n();
    return (
        <>
            <ListItem
                labels={[{ text: i18n.t("absence.add_title"), mode: disabled ? undefined : "cta" }]}
                style={{ marginHorizontal: -marginSize }}
                rightIcon="add"
                rightActionMode="medium"
                rightIconColor={colors.secondary}
                onPress={() => {
                    if (!disabled) {
                        setModalVisible(true);
                    }
                }}
            />
            <AbsenceCreateModal
                visible={modalVisible}
                onClose={() => setModalVisible(false)}
                onCreate={(a) => {
                    setModalVisible(false);
                    onCreate(a);
                }}
                minDate={minDate}
                maxDate={maxDate}
            />
        </>
    );
};

export default AbsenceCreateButton;
